import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Typography, Tag } from 'antd';
import { HomeFilled, DollarCircleFilled, FileFilled, SettingFilled, CarFilled, UserOutlined, MessageFilled, SafetyCertificateOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { realtimeDb, db } from '../firebaseConfig';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';

const { Title } = Typography;

const ControlCard = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [akronim, setAkronim] = useState(null);

  useEffect(() => {
    const loadAkronim = async () => {
      if (!currentUser) return;
      try {
        const userSnap = await getDoc(doc(db, 'users', currentUser.uid));
        if (!userSnap.exists()) return;
        const driverId = userSnap.data().driverId;
        if (!driverId) return;
        const driverSnap = await get(ref(realtimeDb, `drivers/${driverId}/akronim`));
        if (driverSnap.exists()) {
          setAkronim(driverSnap.val());
        }
      } catch (e) {
        console.error('Error loading akronim:', e);
      }
    };
    loadAkronim();
  }, [currentUser]);

  const buttonWrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Центрируем содержимое
    justifyContent: 'center',
    width: '100%',
  };

  const buttonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60px',
    width: '100%', // Кнопка растягивается на всю ширину Col
    borderRadius: '16px',
    backgroundColor: '#f5f5f5',
    border: 'none',
    marginBottom: '8px',
  };

  const iconStyle = {
    fontSize: '18px',
    color: '#333',
  };

  const textStyle = {
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center', // Центрируем текст
    color: '#333',
    
  };

  return (
    <div style={{ padding: '10px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <Title level={4} style={{ margin: 0 }}>Panel sterowania:</Title>
        {akronim && (
          <Tag color="blue" style={{ fontSize: 14, padding: '4px 12px', fontWeight: 600 }}>
            Akronim: {akronim}
          </Tag>
        )}
      </div>
      <Row gutter={[16, 16]} justify="start">
            <Col xs={8} style={buttonWrapperStyle}>
                <Button style={{...buttonStyle, backgroundColor: '#e6f7ff', border: '1px solid #91d5ff'}} onClick={() => navigate('/faktura-ksef')}>
                    <SafetyCertificateOutlined style={{...iconStyle, color: '#1890ff'}} />
                </Button>
                <div style={textStyle}>Faktura KSeF</div>
            </Col>
            <Col xs={8} style={buttonWrapperStyle}>
                <Button style={buttonStyle} onClick={() => navigate('/rozliczenia')}>
                    <DollarCircleFilled style={iconStyle} />
                </Button>
                <div style={textStyle}>Rozliczenie</div>
            </Col>
            <Col xs={8} style={buttonWrapperStyle}>
                <Button style={buttonStyle} onClick={() => navigate('/pomoc')}>
                    <MessageFilled style={iconStyle} />
                </Button>
                <div style={textStyle}>Pomoc</div>
            </Col>
            <Col xs={8} style={buttonWrapperStyle}>
                <Button style={buttonStyle} onClick={() => navigate('/samochod')}>
                    <CarFilled style={iconStyle} />
                </Button>
                <div style={textStyle}>Samochód</div>
            </Col>
            <Col xs={8} style={buttonWrapperStyle}>
                <Button style={buttonStyle} onClick={() => navigate('/dokumenty')}>
                    <HomeFilled style={iconStyle} />
                </Button>
                <div style={textStyle}>Dokumenty</div>
            </Col>
            <Col xs={8} style={buttonWrapperStyle}>
                <Button style={buttonStyle} onClick={() => navigate('/konto')}>
                    <UserOutlined style={iconStyle} />
                </Button>
                <div style={textStyle}>Konto</div>
            </Col>
        </Row>
    
    </div>
  );
};

export default ControlCard;
